module.exports = __webpack_public_path__ + "static/media/product-layout-one.32d02dc4.png";